import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Form, notification, Select, Input } from "antd";
import { connect } from "react-redux";
import API from "../../../api/api";
import { languageLable } from "utilities/helpers";
import axios from "axios";
import { SITE_URL } from "utilities/constants";

var api;

class RegisterVarifyChange extends Component {
  constructor(props) {
    super(props);
    api = new API();
      this.state = {
          countries: [],
          loading: false
      };
    }

    componentDidMount() {
        this.fetchCountries(); 
    }

  static getDerivedStateFromProps(props) {
    if (props.isLoggedIn === true) {
        if (props.isVerified === true) {
            props.history.push("/");
        } else {
            props.history.push("/account/register-verify-btn");
        }
    }
    return false;
    }

    fetchCountries = async () => {
        try {
        const response = await axios.get(`${SITE_URL}countries_b.json`);
        if (response.data) {
            const countriesD = response.data;
            this.setState({ countries: countriesD });
        }
    } catch (error) {
        console.error("🚀 ~ fetchCountries ~ error:", error);
    }
};

  handleFeatureWillUpdate(e) {
    e.preventDefault();
    notification.open({
      message: "Opp! Something went wrong.",
      description: "This feature has been updated later!",
      duration: 500,
    });
  }

  handleLoginSubmit = (values) => {
    const { selectedLanguageData } = this.props.app;

      if (this.props.auth.registerRequestData) {
          this.setState({ loading: true });
      let payload = {
          isdCode: String(this.props.auth.registerRequestData.isdCode || "91"),
          mobile: this.props.auth.registerRequestData.mobile,
        //email: this.props.auth.registerRequestData.email,
          email: this.props.auth.registerRequestData.email// values.email,
      };

      api
        .post("ChangeEmailMobileOTP", {
          data: payload,
        })
        .then((response) => {
            if (response.StatusCode === 200 && response.Result) {
                // Remove register details
                localStorage.removeItem("registerRequestData");

                // SET DATA TO REDUX
                this.props.dispatch({
                    type: "REGISTER_REQEUST",
                    registerRequestData: payload,
                });
                localStorage.setItem("registerRequestData", JSON.stringify(payload));
                localStorage.setItem("validateapiroute", "ValidateUpdateEmailAndMobileOtp");
                localStorage.setItem("newEmailVr", values.email);
                localStorage.setItem("newisdCodeVr", values.isdCode === "91 - India" ? "91" : values.isdCode );
                localStorage.setItem("newmobileVr", values.mobile);

              this.props.history.push("/account/register-varify-existing");
            } else {
                this.setState({ loading: false });
            notification.info({
              message: "info",
              description: languageLable(selectedLanguageData, response.StatusMessage),
            });
          }
        });
    } else {
    }
  };

  onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
    };

    isdCodeSelector() {
        return (
            <Form.Item name="isdCode" noStyle initialValue= "91 - India">
                <Select
                    style={{ width: 100 }}
                    showSearch
                    optionFilterProp="children"
                >
                    {(this.state.countries || []).map((item) => (
                        <Select.Option key={item.phone_code} value={item.phone_code}>
                            {item.phone_code} - {item.name}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>
        );
    }

  render() {
    const { selectedLanguageData } = this.props.app;

    return (
      <div className="ps-my-account">
        <div className="container">
          <Form
            className="ps-form--account"
            onFinish={(values) => this.handleLoginSubmit(values)}
            onFinishFailed={() => this.onFinishFailed()}
          >
            <ul className="ps-tab-list">
              <li className="active">
                <Link to="/account/login">
                  {languageLable(selectedLanguageData, "Verification")}
                </Link>
              </li>
            </ul>
            <div className="ps-tab active" id="sign-in">
                <div className="ps-form__content">
                <div className="form-group">
                    <Form.Item
                        label={languageLable(selectedLanguageData, "Current email:") + " " + this.props.auth.registerRequestData.email}
                        colon={false} // Optional: removes colon after label
                    >
                    </Form.Item>
                </div>
                <div className="form-group">
                    <Form.Item
                        label={languageLable(selectedLanguageData, "Current mobille:") + " " + this.props.auth.registerRequestData.isdCode + " " + this.props.auth.registerRequestData.mobile}
                        colon={false} // Optional: removes colon after label
                    >
                    </Form.Item>
                </div>
                <div className="form-group">
                    <Form.Item
                        name="mobile"
                        rules={[
                            {
                                required: true,
                                message: languageLable(
                                    selectedLanguageData,
                                    "Please enter mobile number."
                                ),
                            },
                        ]}
                    >
                        <Input
                            addonBefore={this.isdCodeSelector()}
                            id="mobile"
                            name="mobile"
                            placeholder={languageLable(
                                selectedLanguageData,
                                "Mobile Number*"
                            )}
                            type="text"
                        />
                    </Form.Item>
                </div>
                <div className="form-group form-forgot">
                    <Form.Item
                        name="email"
                        rules={[
                            {
                                type: "email",
                                required: true,
                                message: languageLable(
                                    selectedLanguageData,
                                    "Please enter email"
                                ),
                            },
                        ]}
                    >
                        <input
                            id="email"
                            className="form-control"
                            name="email"
                            type="email"
                            placeholder={languageLable(selectedLanguageData, "Email Id*")}
                        ></input>
                    </Form.Item>
                </div>
                <div className="form-group submit">
                  <button type="submit" className="ps-btn ps-btn--fullwidth" disabled={this.state.loading}>
                                    {this.state.loading
                                        ? languageLable(selectedLanguageData, "Loading...")
                                        : languageLable(selectedLanguageData, "Update")}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

export default connect(mapStateToProps)(withRouter(RegisterVarifyChange));
